module.exports = __webpack_public_path__ + "media/images/landing/home/categories/photo-9e27f383ec5d8b87026a600f5070c51b.png";